module.exports = __webpack_public_path__ + "img/icon_benefit_07_w.ff86d5f7.svg";